import { AxiosError } from "axios";
import { ApiProvider } from "../ApiProvider";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

type TInitialState = {
	isLoading: boolean;
	isInitialized: boolean;
	error: string | null;
};

export type TContactUserPayload = {
	description: string;
	subject: string;
	company_name: string;
};

export interface IContactUserSupportResponse {
	id: number;
	subject: string;
	description: string;
	description_text: string;
	status: number;
	priority: number;
	company_id: number;
	group_id: number;
	requester_id: number;
	responder_id: number | null;
	source: number;
	spam: boolean;
	urgent: boolean;
	is_escalated: boolean;
	to_emails: Array<string>;
	cc_emails: Array<string>;
	reply_cc_emails: Array<string>;
	fwd_emails: Array<string>;
	attachments: Array<unknown>;
	tags: Array<string>;
	created_at: string;
	updated_at: string;
}

export interface IContactUserResponse {
	success: boolean;
	supportResponse: IContactUserSupportResponse;
}

const initialState: TInitialState = {
	isLoading: false,
	isInitialized: false,
	error: null,
};

export const createContactUserEmail = createAsyncThunk<IContactUserResponse, TContactUserPayload>(
	"contactUser/createContactUserEmail",
	async (payload, { rejectWithValue }) => {
		try {
			const body = new URLSearchParams();
			body.append("description", encodeURIComponent(payload.description));
			body.append("subject", payload.subject);
			body.append("company_name", payload.company_name);

			const response = await ApiProvider.default.axios.post<IContactUserResponse>(
				`/api/System/CreateHelpRequestEmail?_dc=${Date.now()}`,
				body,
				{ headers: { "Content-Type": "application/x-www-form-urlencoded" } },
			);
			return response.data;
		} catch (error) {
			if (error instanceof AxiosError) return rejectWithValue(error.message);
			return rejectWithValue("Unknown error");
		}
	},
);

export const contactUserSlice = createSlice({
	name: "contactUser",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(createContactUserEmail.pending, (state) => {
				state.isLoading = true;
				state.isInitialized = true;
			})
			.addCase(createContactUserEmail.fulfilled, (state) => {
				state.isLoading = false;
			})
			.addCase(createContactUserEmail.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload as string;
			});
	},
});
